const review = {
  name: '',
  phone: '',
  verificationTicket: '',
}

export { review }
